export const MED_TEST_RESULT_STATUSES_KEYS = {
  APPOINTMENT_COMPLETED: 'appointmentCompleted',
  TEST_COMPLETED: 'testCompleted',
  ROF: 'ROF',
};
